import React from 'react';

import './index.scss';

//material-ui
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

//custom components
import CustomButton from '../../../../components/basic/CustomButton';

//api
import {api} from '../../../../functions/api'

//other libraries
import { inject, observer } from 'mobx-react';
import Dropzone from 'react-dropzone'

@inject('internal')
@inject('translate')
@observer
export default class ImportProducts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploading: false,
            file: null,
            extension: null,
            duplicates: [],
            response: null
        }
    }

    handleDrop = (files) => {
        if(files[0] !== undefined) {
            let fileNameArr = files[0].name.split('.');

            let extension = fileNameArr[fileNameArr.length - 1]
            if(extension === "xls" || extension === "xlsx") {
                this.setState({
                    file: files[0],
                    extension: extension,
                })
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FORMAT_IS_NOT_VALID, true)
        }
        
    }

    handleImport = async() => {
        this.setState({uploading: true})
        if(this.state.file === null) {
            this.setState({uploading: false})
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.EMPTY_FILE, true)
            return
        }
        let upload_data = await api({
            method: 'post',
            url: 'products/import',
            formData: true,
            formDataDoc: true,
            authorization: this.props.internal.user.access_token,
            params: {
                file: this.state.file
            }
        })

        if(upload_data.success === true) {
            
            let created = this.props.translate.i18n.MODULES.PRODUCTS.IMPORT_RESULT.CREATED + upload_data.data.data.created;
            let disabled = this.props.translate.i18n.MODULES.PRODUCTS.IMPORT_RESULT.DISABLED + upload_data.data.data.disabled;
            let enabled = this.props.translate.i18n.MODULES.PRODUCTS.IMPORT_RESULT.ENABLED + upload_data.data.data.enabled;
            let updated = this.props.translate.i18n.MODULES.PRODUCTS.IMPORT_RESULT.UPDATED + upload_data.data.data.updated;
            let resultString = created + "\n" + disabled + "\n" + enabled + "\n" + updated + "\n";
            // if(upload_data.data.data.duplicates.length > 0) {
            if(upload_data.data.data) {
                this.setState({duplicates: upload_data.data.data.duplicates, response: upload_data.data.data})
            }
            else {
                this.props.onClose(true)
            }

            this.setState({uploading: false})
            // this.props.internal.setSnackbar(resultString, true)
            
            
        }
        else{
            this.props.internal.setSnackbar(upload_data.data.message, true)
            this.setState({uploading: false})
        }
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                
            >
                <DialogTitle className={'title'}>{this.state.response !== null ? this.props.translate.i18n.MODULES.PRODUCTS.IMPORT_RESULT.RESULT_HAS_DUPLICATES :this.props.title}</DialogTitle>
                <DialogContent className={`import-products-dialog ${this.state.duplicates.length ? "duplicates": ""}` }>
                {this.state.response !== null ?
                <div className={'import-results'}>
                    <p>{this.props.translate.i18n.MODULES.PRODUCTS.IMPORT_RESULT.CREATED} {this.state.response.created}</p>
                    <p>{this.props.translate.i18n.MODULES.PRODUCTS.IMPORT_RESULT.DISABLED} {this.state.response.disabled}</p>
                    <p>{this.props.translate.i18n.MODULES.PRODUCTS.IMPORT_RESULT.ENABLED} {this.state.response.enabled}</p>
                    <p>{this.props.translate.i18n.MODULES.PRODUCTS.IMPORT_RESULT.UPDATED} {this.state.response.updated}</p>
                </div>
                :
                null
                }
                {this.state.duplicates.length ? <p className={'duplicates-subtitle'}>{this.props.translate.i18n.MODULES.PRODUCTS.IMPORT_RESULT.RESULT_HAS_DUPLICATES_SUBTITLE}</p> : null}
                
                {this.state.duplicates.length ?
                <div>
                    <ol>
                    {this.state.duplicates.map((duplicate, index) => {
                        return (
                            <li key={index}>{duplicate}</li>
                        )
                    })}
                    </ol>
                </div>
                :
                null}
                {this.state.response === null?
                <Dropzone
                    onDrop={files => this.handleDrop(files)}
                    // disableClick
                    multiple={false}
                    accept={[".xlsx", ".xls"]}
                    >
                    {({getRootProps, getInputProps, open}) => (
                        <div {...getRootProps()} className={`dropzone ${this.state.file !== null ? "dropped":""}`}>
                        <input {...getInputProps()} />
                            {this.state.file !== null && this.state.file.name?
                                <p>{this.state.file.name}</p>
                                :
                                <p>{this.props.translate.i18n.MODULES.CLIENTS.IMPORT_PLACE}</p>
                            }
                            

                            {/* <button type="button" onClick={() => open()}>
                            {this.props.translate.i18n.MODULES.CLIENTS.IMPORT_CLIENTS_BUTTON}
                            </button> */}
                        </div>
                    )}
                    </Dropzone>
                    :
                    null
                }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    {this.state.duplicates.length ?
                        null
                        :
                        <CustomButton
                            justText
                            progressBar={this.state.uploading}
                            onClick={this.handleImport}
                            mystyle={'btn-white-bg'}
                            title={this.props.translate.i18n.GLOBAL.BUTTONS.IMPORT}
                        />
                    }
                </DialogActions>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/products/list/import/index.js